// DataGridTable.js

import { useState } from "react";
import Propertybanner from "./Propertybanner"; // Ensure this matches the file and component name exactly
import "../CSS/DataGridTable.css";
import { useAuth0 } from "@auth0/auth0-react";

const DataGridTable = ({
  data,
  onSelectItem,
  // new pagination props:
  loading,
  page,
  setPage,
  count,
  pageSize = 50
}) => {
  const [activeBanner, setActiveBanner] = useState(null);
  const { user } = useAuth0();

  const handleBannerClick = (id, item) => {
    const isDeactivating = activeBanner === id;
    setActiveBanner(isDeactivating ? null : id);
    onSelectItem(isDeactivating ? null : item);
  };

console.log("DataGridTable render:", data);


  return (
    <div className="dataTable">
      {data.map((item, index) => (
        <Propertybanner
          key={item._id}
          Profile={user}
          propertyId={item._id}
          imageUrl1={item.ImageLink}
          imageUrl2={item.PhotoURLs}
          priceType={item.Price.Type}
          price={`£${item.Price.Value}`}
          OldPrice={item.Price.OldValues}
          size={`${item.Space}m2`}
          Status={item.Status}
          pricePerMeter={`£${(item.Price.Value / item.Space).toFixed(0)}/m2`}
          address={item.Address}
          description={`Semi Detached - ${item.Bedrooms} Bed - ${item.Bathrooms} Bath - ${item.Sittingrooms} Sitting`}
          Type={item.Type}
          Bathrooms={item.Bathrooms}
          Bedrooms={item.Bedrooms}
          Sittingrooms={item.Sittingrooms}
          addedDate={item.TimeStamp.slice(0, 10)}
          viewLink={item.URL}
          isActive={activeBanner === index}
          FloorPlans={item.FloorPlanURLs}
          ScotLISLink={item.ScotLISLink}
          PriceHistory={item.ESPC?.PriceHistory ?? []}
          onClick={() => handleBannerClick(index, item)}
        />
      ))}

      {/* Pagination Controls */}
      <div style={{ textAlign: 'center', margin: '1rem 0' }}>
        {loading && page > 0 ? (
          <span>Loading more…</span>
        ) : (
          data.length < count && (
            <button
              onClick={() => setPage(p => p + 1)}
              disabled={loading}
            >
              Load Next
            </button>
          )
        )}
      </div>
    </div>
  );
};

export default DataGridTable;
